import { STATICS } from 'statics'

export const PAYMENT_TYPE = {
  PIX: 'PIX',
  BANK_SLIP: 'BANK_SLIP',
  CARD: 'CARD',
}

export const PAYMENT_OPTIONS_DATA = [
  {
    type: PAYMENT_TYPE.PIX,
    label: 'Pagar com PIX',
    icon: <STATICS.PIX_PAYMENT_ICON />,
  },
  {
    type: PAYMENT_TYPE.BANK_SLIP,
    label: 'Baixar fatura',
    icon: <STATICS.ALTERNATIVE_DOWNLOAD />,
  },
  {
    type: PAYMENT_TYPE.BANK_SLIP,
    label: 'Copiar código',
    icon: <STATICS.BAR_CODE />,
    copyToClipboard: true,
    copyMessage: 'Código de barras copiado!',
  },
  {
    type: PAYMENT_TYPE.CARD,
    label: 'Pagar com Cartão',
    icon: <STATICS.CREDIT_CARD />,
  },
]

export const PAYMENT_ERROR_MESSAGE =
  'No momento, só é possível pagar via Boleto. Você pode efetuar o pagamento agora ou aguardar alguns minutos e tentar novamente.'

export const GET_PAYMENT_URL_ERROR_MESSAGE = 'Erro na busca do link para pagamento.'
